// extracted by mini-css-extract-plugin
module.exports = {"filters":"PostsMosaicFilters_filters__v1EsG","tags":"PostsMosaicFilters_tags__HBtGb","search":"PostsMosaicFilters_search__WHbW6","stats":"PostsMosaicFilters_stats__xOWL_"};